export const CHECK_EMAIL = 'CHECK_EMAIL';
export const CHECK_EMAIL_SUCCEEDED = 'CHECK_EMAIL_SUCCEEDED';
export const CHECK_EMAIL_FAILED = 'CHECK_EMAIL_FAILED';

export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCEEDED = 'VERIFY_EMAIL_SUCCEEDED';
export const VERIFY_EMAIL_FAILED = 'VERIFY_EMAIL_FAILED';

export const FILL_PROFILE = 'FILL_PROFILE';
export const FILL_PROFILE_SUCCEEDED = 'FILL_PROFILE_SUCCEEDED';
export const FILL_PROFILE_FAILED = 'FILL_PROFILE_FAILED';

export const VERIFY_PASSWORD = 'VERIFY_PASSWORD';
export const VERIFY_PASSWORD_SUCCEEDED = 'VERIFY_PASSWORD_SUCCEEDED';
export const VERIFY_PASSWORD_FAILED = 'VERIFY_PASSWORD_FAILED';

export const RESET_STEP = 'RESET_STEP';

export const REQUEST_PASSWORD_RESET = 'RESET_PASSWORD_RESET';
export const REQUEST_PASSWORD_RESET_SUCCEEDED = 'REQUEST_PASSWORD_RESET_SUCCEEDED';
export const REQUEST_PASSWORD_RESET_FAILED = 'REQUEST_PASSWORD_RESET_FAILED';
export const REQUEST_PASSWORD_RESET_REDIRECT = 'REQUEST_PASSWORD_RESET_REDIRECT';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCEEDED = 'RESET_PASSWORD_SUCCEEDED';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_PASSWORD_DISMISS_ERROR = 'RESET_PASSWORD_DISMISS_ERROR';

export const RESTORE_SESSION = 'RESTORE_SESSION';
export const RESTORE_SESSION_SUCCEEDED = 'RESTORE_SESSION_SUCCEEDED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCEEDED = 'LOGOUT_SUCCEEDED';

export const REQUEST_RESET_PASSWORD_CODE = 'REQUEST_RESET_PASSWORD_CODE';
export const REQUEST_RESET_PASSWORD_CODE_SUCCESS = 'REQUEST_RESET_PASSWORD_CODE_SUCCESS';
export const REQUEST_RESET_PASSWORD_CODE_FAIL = 'REQUEST_RESET_PASSWORD_CODE_FAIL';
export const VERIFY_RESET_PASSWORD_CODE = 'VERIFY_RESET_PASSWORD_CODE';
export const VERIFY_RESET_PASSWORD_CODE_SUCCESS = 'VERIFY_RESET_PASSWORD_CODE_SUCCESS';
export const VERIFY_RESET_PASSWORD_CODE_FAIL = 'VERIFY_RESET_PASSWORD_CODE_FAIL';
export const SET_RESET_PASSWORD = 'SET_RESET_PASSWORD';
export const SET_RESET_PASSWORD_SUCCESS = 'SET_RESET_PASSWORD_SUCCESS';
export const SET_RESET_PASSWORD_FAIL = 'SET_RESET_PASSWORD_FAIL';
